import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "uk-section" }
const _hoisted_2 = { class: "uk-container" }
const _hoisted_3 = { class: "uk-card uk-card-default uk-border-rounded uk-margin-large-top" }
const _hoisted_4 = { class: "uk-card-body uk-padding-small" }
const _hoisted_5 = {
  key: 0,
  class: "guest uk-grid-small uk-flex-bottom uk-flex-left",
  "uk-grid": ""
}
const _hoisted_6 = { class: "uk-width-auto" }
const _hoisted_7 = { class: "uk-card uk-card-body uk-card-small uk-card-default uk-border-rounded" }
const _hoisted_8 = { class: "uk-margin-remove" }
const _hoisted_9 = {
  key: 1,
  class: "me uk-grid-small uk-flex-bottom uk-flex-right uk-text-right",
  "uk-grid": ""
}
const _hoisted_10 = { class: "uk-width-auto" }
const _hoisted_11 = { class: "uk-card uk-card-body uk-card-small uk-card-primary uk-border-rounded" }
const _hoisted_12 = { class: "uk-margin-remove" }
const _hoisted_13 = { class: "uk-card-footer uk-padding-remove" }
const _hoisted_14 = {
  class: "uk-grid-small uk-flex-middle",
  "uk-grid": ""
}
const _hoisted_15 = { class: "uk-width-expand" }
const _hoisted_16 = { class: "uk-padding-small uk-padding-remove-horizontal" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, chatIdx) => {
              return (_openBlock(), _createElementBlock("div", { key: chatIdx }, [
                (message.sender.type == 'driver')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("p", _hoisted_8, _toDisplayString(message.text), 1)
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("p", _hoisted_12, _toDisplayString(message.text), 1)
                        ])
                      ])
                    ]))
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "uk-width-auto" }, null, -1)),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("textarea", {
                    class: "uk-textarea uk-padding-remove uk-border-remove",
                    rows: "1",
                    placeholder: "Write a message...",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.message) = $event)),
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.sendMessage($event)), ["exact"]), ["enter"]))
                  }, null, 544), [
                    [_vModelText, _ctx.message]
                  ])
                ])
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "uk-width-auto" }, null, -1))
            ])
          ])
        ])
      ])
    ])
  ]))
}